<template>
	<div>
		<footer>
			<div class="row">
				<div class="columns column3">
					<div class="footer-logo" />
				</div>
				<div class="columns column3">
					<h3>{{ $t('footerAddress') }}</h3>
					<p>
						<span>{{ defaults[locale].website.hotelName }}</span>
						<br />
						<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span>
						<br />
						<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span>
						<br />
						<span>{{ defaults[locale].website.country }}</span>
						<br />
					</p>
					<social-media :socials="socials" />
				</div>
				<div class="columns column3">
					<h3>{{ $t('footerContact') }}</h3>
					<p>
						<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
							<span>{{ defaults[locale].website.phone }}</span>
						</a>
						<br />
						<a :href="`mailto:${defaults[locale].website.email}`">
							<span>{{ defaults[locale].website.email }}</span>
						</a>
					</p>
				</div>
				<div class="columns column3">
					<h3>{{ $t('footerNavigate') }}</h3>
					<p>
						<nuxt-link v-for="item in footermenu[locale]" :key="item.filename" :to="item.filename">
							{{ item.header }} <br />
						</nuxt-link>
						<span v-if="defaults[locale].cookieConsent.published">
							<a href="#" @click.prevent="openConsent">{{ $t('consentOpen') }}</a>
						</span>
					</p>
				</div>
			</div>
			<div class="row author">
				<div class="columns column12 align-center">
					<div class="bottomfooter-row">
						<p class="align-left">
							<a
								href="https://www.porterforhotels.com/hotel-websites"
								target="_blank"
								rel="noopener noreferrer"
								title="Hotel website design by Porter"
							>
								Hotel Website Design
							</a>
							by:
							<a href="https://porterforhotels.com" target="_blank">
								<img class="siteByLogo" :src="$t('siteByLogo')" loading="lazy" alt="" />
								Porter</a
							>
						</p>
						<div class="menu align-right">
							<span v-for="(item, idx) in bottomfooter[locale]" :key="item.filename">
								<nuxt-link :to="item.filename">
									{{ item.header }}
								</nuxt-link>
								<span v-if="idx < bottomfooter[locale].length - 1"> | </span>
							</span>
						</div>
					</div>
				</div>
			</div>
		</footer>
	</div>
</template>

<script setup>
const { data: footer } = await useWebsiteFetch('footermenu');
const { footermenu, bottomfooter } = footer.value;
const { locale } = useI18n();
const { openConsent } = useCookieConsent();

const { defaults, socials, fetchDefaults } = useDefaults();

await fetchDefaults();
</script>

<style lang="scss" scoped>
footer {
	background: var(--footer-background-color);
	color: var(--footer-link-color);
	padding: 200px 0 25px;
	font-size: 0.85rem;
}

a {
	color: var(--footer-link-color);
	text-decoration: none;

	&:hover {
		color: var(--primary-color);
	}
}

h3 {
	color: #fff;
	font-size: 20px;
	font-weight: 600;
}

.footer-logo {
	width: 129px;
	height: 180px;
	background: url('~/assets/images/logo-hotelheteiland-footer-white.png') no-repeat center center;
	background-size: 129px;
}

.author {
	margin: 25px auto 0;
	font-size: 12px;
	padding: 20px 0;

	p {
		margin: 0;
		font-size: 12px;
	}

	img {
		max-width: 20px;
		margin: 0 1px 0 2px;
	}
}

.bottomfooter-row {
	display: flex;
	align-items: center;
	border-top: 1px solid #efeddf;
	padding: 20px 0 0;

	.menu {
		margin-left: auto;
	}
}

@media (max-width: 900px) {
	footer .columns {
		margin: 20px auto;
		text-align: left;
	}

	.author {
		margin-bottom: 20px;
	}

	footer.author .columns {
		text-align: center;
	}
}

@media (max-width: 900px) {
	footer .columns {
		text-align: center;
	}

	.bottomfooter-row {
		flex-flow: column-reverse wrap;

		.menu {
			text-align: center;
			margin: 0 auto 20px;
		}
	}
}

@media (max-width: 600px) {
	.footer-logo {
		display: none;
	}

	footer {
		padding-top: 50px;
	}
}
</style>
